module.exports = __webpack_public_path__ + "media/images/mobile/solutions/telecom-mb-bg-c8a62d7b939c188da5ec412eeec2e278.png";